import React from 'react';
import { ApButtonIcon, ApButtonSecondary } from '@alixpartners/ui-components';
import { Wrapper, ButtonsWrapper } from './ApProjectFooter.styles';

export const ApProjectFooter = ({ onReset, onExpand, canEdit }) => {
	const expandAll = () => {
		onExpand();
	};
	const collapseAll = () => {
		onExpand(false);
	};

	return (
		<Wrapper>
			<ButtonsWrapper>
				<ApButtonIcon iconName="unfold_more" onClick={expandAll} />
				<ApButtonIcon iconName="unfold_less" onClick={collapseAll} />
				<ApButtonSecondary onClick={onReset} disabled={canEdit}>
					Reset
				</ApButtonSecondary>
			</ButtonsWrapper>
		</Wrapper>
	);
};

export default ApProjectFooter;
